export default class IpsImageUpload {
    constructor(loader, editor) {
        this.loader = loader;
        this.editor = editor;
    }

    upload() {
        const event = new CustomEvent("on-editor-ips-insert-image", {
            bubbles: true,
        });
        return this.loader.file.then(file => {
            return new Promise((resolve, reject) => {
                this.editor.fire('on-editor-ips-paste-drop-image', {
                    file,
                    resolve,
                    reject,
                    loader: this.loader
                });
            });
        });
    }

    abort() {
        //optional
    }
}
